/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".left-28[_ngcontent-%COMP%]{margin-left:28px}.left-40[_ngcontent-%COMP%]{margin-left:40px}.left-10[_ngcontent-%COMP%]{margin-left:10px}.right-10[_ngcontent-%COMP%]{margin-right:10px}.margin-10[_ngcontent-%COMP%]{margin:10px}.margin-20[_ngcontent-%COMP%]{margin:20px}.cus-col-md-1[_ngcontent-%COMP%]{flex:0 0 5.333333%;max-width:8.333333%}.bg-color[_ngcontent-%COMP%]{background-color:#f3f3f3}.cmn-border[_ngcontent-%COMP%]{border:1px solid #d6d6d6}.img-icon[_ngcontent-%COMP%]{width:20px}"];
export { styles as styles };
